import { useQuery } from "urql"
import { Link } from "react-router-dom"
import { ScrollArea } from "@/components/ui/scroll-area"
import { Skeleton } from "@/components/ui/skeleton"
import { CheckCircle } from "lucide-react"
import { StatusBadge } from "@/components/shared/status-badge"
import { TimeAgo } from "@/components/shared/time-ago"
import { DeliveriesQuery } from "@/lib/graphql/queries"

export function RecentFailures() {
  const [result] = useQuery({
    query: DeliveriesQuery,
    variables: { status: "FAILED" as const, limit: 15, offset: 0 },
  })

  const deliveries = result.data?.deliveries.nodes ?? []

  return (
    <div className="rounded-lg glass-card flex flex-col overflow-hidden">
      <div className="flex items-center justify-between px-5 py-4 border-b border-border/50">
        <h3 className="text-sm font-semibold">Recent Failures</h3>
        <Link
          to="/deliveries?status=FAILED"
          className="text-xs text-muted-foreground hover:text-foreground transition-colors"
        >
          View all
        </Link>
      </div>
      <div className="flex-1 py-2">
        <ScrollArea className="h-87.5">
          {result.fetching ? (
            <div className="space-y-3 px-5">
              {Array.from({ length: 5 }).map((_, i) => (
                <Skeleton key={i} className="h-12 w-full" />
              ))}
            </div>
          ) : deliveries.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full gap-2">
              <CheckCircle className="h-6 w-6 text-emerald-500/70" />
              <span className="text-sm text-muted-foreground">No failures</span>
            </div>
          ) : (
            <div className="divide-y divide-border/30 px-3">
              {deliveries.map((d) => (
                <Link
                  key={d.id}
                  to={`/deliveries/${d.id}`}
                  className="flex items-center justify-between px-2 py-3 rounded-md hover:bg-accent/50 transition-colors"
                >
                  <div className="flex items-center gap-3 min-w-0">
                    <StatusBadge status={d.status} />
                    <div className="min-w-0">
                      <div className="text-xs font-medium truncate">
                        {d.destination.name}
                      </div>
                      <div className="text-2xs text-muted-foreground truncate">
                        {d.event.eventType}
                      </div>
                    </div>
                  </div>
                  <div className="text-right shrink-0">
                    <div className="text-2xs text-muted-foreground tabular-nums">
                      {d.attempts}/{d.maxAttempts}
                    </div>
                    <TimeAgo date={d.createdAt} />
                  </div>
                </Link>
              ))}
            </div>
          )}
        </ScrollArea>
      </div>
    </div>
  )
}
